<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6">
          Input kode Container
        </v-card-title>

        <v-container>
          <v-text-field
            v-model="formData.kc"
            label="KC"
            outlined
            hide-details
            @keydown.enter="checkKC"
            :disabled="loading"
            :loading="loading"
            autofocus
          ></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "FindKCModal",
  props: ["openModal"],
  data() {
    return {
      formData: {
        kc: ""
      },
      loading: false
    };
  },
  watch: {
    openModal(val) {
      if (val) {
        this.formData.kc = "";
      }
    },
    "formData.kc"(val) {
      if (val) {
        this.formData.kc = val.toUpperCase();
      }
    }
  },
  methods: {
    async checkKC() {
      this.loading = true;

      await axios
        .post(`check-kc`, this.formData)
        .then(res => {
          this.loading = false;

          if (Object.keys(res.data).length === 0) {
            this.fetchNewData();
          } else {
            this.fetchContainerData(res.data.id);
          }
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async fetchNewData() {
      this.laoding = true;

      await axios
        .get(`kc`)
        .then(res => {
          this.loading = false;

          this.$emit("close-modal", res.data);
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async fetchContainerData(id) {
      this.loading = true;

      await axios
        .get(`container/${id}`)
        .then(res => {
          this.loading = false;

          this.$emit("close-modal", res.data);
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    }
  }
};
</script>
